const firebaseConfig = {
  apiKey: "AIzaSyBbWAw-V7CW65sThjPVoD-P4OcQq_BSj2M",
  authDomain: "digital-innovation-lab-nagoya.firebaseapp.com",
  projectId: "digital-innovation-lab-nagoya",
  storageBucket: "digital-innovation-lab-nagoya.appspot.com",
  messagingSenderId: "644977438972",
  appId: "1:644977438972:web:d8728ebf584a27d6bc6779",
  measurementId: "G-DXT4BZQFMQ"
};

export default firebaseConfig;
